export default {
      id: "i-close1-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/sprite.svg#i-close1",
      toString: function () {
        return this.url;
      }
    }